<app-network-banner />

@if (showGraceWarning) {
<aside class="session-grace-banner" role="alert" aria-live="assertive">
  <div class="session-grace-banner-inner">
    <div class="session-grace-banner-leading">
      <svg class="session-grace-banner-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"></path>
        <line x1="12" y1="9" x2="12" y2="13"></line>
        <line x1="12" y1="17" x2="12.01" y2="17"></line>
      </svg>
      <span class="session-grace-banner-message">
        Concurrent login detected. Session will close in <strong>{{ graceCountdown }}s</strong>. Please finish and save your work.
      </span>
    </div>
    <button type="button" class="btn-grace-logout" (click)="completeForcedLogout()">
      Log Out Now
    </button>
  </div>
</aside>
}

<router-outlet />
<app-toast />


@if (showConflictOverlay) {
<div class="whatsapp-overlay">
  <div class="whatsapp-card">
    <div class="whatsapp-icon">
      <div class="icon-circle">
        <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#25D366" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
          <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
        </svg>
      </div>
    </div>
    <h2>WyberAI is active on another device</h2>
    <p>Log in here to use WyberAI. Your other session will be terminated to ensure security.</p>
    
    <div class="metadata-section">
        <div class="metadata-item">
            <span class="label">Device:</span>
            <span class="value">{{deviceInfo}}</span>
        </div>
        <div class="metadata-item">
            <span class="label">Location (IP):</span>
            <span class="value">{{ipAddress}}</span>
        </div>
    </div>

    <div class="whatsapp-actions">
      <button class="btn-cancel" (click)="handleCancel()" [disabled]="useHereLoading">LOGOUT</button>
      <button class="btn-use-here" (click)="handleUseHere()" [disabled]="useHereLoading">
        @if (useHereLoading) {
          <span class="spinner"></span> CONNECTING...
        } @else {
          USE HERE
        }
      </button>
    </div>
    @if (useHereError) {
      <p class="use-here-error">{{ useHereError }}</p>
    }
  </div>
</div>
} @else if (showTerminatedOverlay) {
<div class="whatsapp-overlay">
  <div class="whatsapp-card terminated">
    <div class="whatsapp-icon">
      <div class="icon-circle error">
        <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#ff4d4d" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"></path>
          <line x1="12" y1="9" x2="12" y2="13"></line>
          <line x1="12" y1="17" x2="12.01" y2="17"></line>
        </svg>
      </div>
    </div>
    <h2>Session Terminated</h2>
    <p>{{ terminatedMessage || 'Your session was ended because this account was logged in from another device.' }}</p>
    <div class="whatsapp-actions single">
      <button class="btn-ok" (click)="dismissTerminatedOverlay()">OK</button>
    </div>
  </div>
</div>
} @else if (showOtherTabOverlay) {
<div class="whatsapp-overlay">
  <div class="whatsapp-card">
    <div class="whatsapp-icon">
      <div class="icon-circle warning">
        <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#f59e0b" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <rect x="2" y="3" width="20" height="18" rx="2"></rect>
          <path d="M2 7h20"></path>
          <path d="M7 3v4"></path>
          <path d="M17 3v4"></path>
        </svg>
      </div>
    </div>
    <h2>WyberAI is open in another tab</h2>
    <p>Only one tab can be active at a time. Click below to use WyberAI in this tab — your session is still valid.</p>
    <div class="whatsapp-actions single">
      <button class="btn-use-here" (click)="handleUseThisTab()">USE THIS TAB</button>
    </div>
    <button class="btn-signout" (click)="handleCancel()">Sign out</button>
  </div>
</div>
}
